// navigation (responsive)
(() => {

  const html = document.documentElement;
  const header = document.querySelector('.page-header');
  const button = document.querySelector('.main-navigation-button');
  const nav = document.querySelector('.main-navigation');

  // Stop execution if one of the required elements is missing
  if (!header || !button || !nav) return;

  const breakpoint = Number(nav.dataset.breakpoint) || 0;
  let wasBelow800 = window.innerWidth < breakpoint;

  function debounce(fn, delay = 150) {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  }

  // Open the navigation in collapsed mode
  function openNav() {
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('opened');
    nav.inert = false;
  }

  // Close the navigation in collapsed mode
  function closeNav() {
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('opened');
    nav.inert = true;
  }

  // Enable expanded mode when the navigation fits into the available space
  function enableExpandedMode() {
    button.inert = true;
    button.classList.remove('opened');
    button.setAttribute('aria-expanded', 'true');
    nav.inert = false;
    html.removeAttribute('data-menu-closed');
  }

  // Enable collapsed mode when the navigation no longer fits
  function enableCollapsedMode() {
    button.inert = false;
    closeNav();
    html.setAttribute('data-menu-closed', '');
  }

  function updateMenuState(isBelow800) {
    if (isBelow800) {
      html.setAttribute('data-menu-closed', '');
      enableCollapsedMode();
    } else {
      html.removeAttribute('data-menu-closed');
      enableExpandedMode();
    }
  }

  function checkBreakpointCrossing() {
    const isBelow800 = window.innerWidth < breakpoint;

    if (isBelow800 !== wasBelow800) {
      updateMenuState(isBelow800);
      wasBelow800 = isBelow800;
    }
  }

  // Toggle the navigation open/closed when the button is clickable
  button.addEventListener('click', () => {
    if (button.inert) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      closeNav();
    } else {
      openNav();
    }
  });

// Bei Load initial setzen
  updateMenuState(wasBelow800);

// Bei Resize debounced prüfen
  window.addEventListener('resize', debounce(checkBreakpointCrossing, 150));
})();